import antdPT from 'antd/lib/locale/pt_PT';
import saMessages from '../locales/pt_PT.json';

const esLang = {
  messages: {
    ...saMessages,
  },
  antd: antdPT,
  locale: 'pt-PT',
};

export default esLang;
